/* eslint react/jsx-key: off */
import React from 'react';
import { translate } from 'react-admin';

const ProductTitle = translate(({ record, translate }) => (
    <span>
        {record ? translate('resources.products.edit.title', { title: record.name }) : ''}
    </span>
));

export default ProductTitle;
